import { CONSENT_KEYS } from './constants';

export type CollectConsentParams = {
  source: string;
  consentKeys: typeof CONSENT_KEYS;
  displayedText: string;
  formUrl?: string;
};

export const collectConsent = async () => {
  const { origin } = window.location;

  const consentHubUrl = `${origin}/gateway/api/consenthub/session/user`;

  try {
    const response = await fetch(consentHubUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(err);
    throw err;
  }
};

export const updateConsent = async ({ source, consentKeys, displayedText }: CollectConsentParams) => {
  const { origin, href } = window.location;

  const consentHubUrl = `${origin}/gateway/api/consenthub/session/user`;
  const consentInput = {
    formUrl: href,
    locale: 'UNKNOWN',
    site: 'atlassian',
    source,
    action: 'FORM_FILL',
    consents: consentKeys.map((consentKey) => ({
      key: consentKey,
      granted: true,
      displayedText,
    })),
  };

  try {
    const response = await fetch(consentHubUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(consentInput),
    });
    return response;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(err);
    throw err;
  }
};
